export default "__VITE_ASSET__256562a6__"